<div class="position-dialog">
  <h2 mat-dialog-title>{{eventTitle}}</h2>
  <div mat-dialog-content>
    <form [formGroup]="eventForm">
      <!-- Name -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" maxlength="50" (input)="onNameInput()"
            [readonly]="eventForm.get('name')?.disabled" />
          <!-- Show character count only after typing begins -->
          <mat-hint align="end" *ngIf="showCharCount">
            {{ characterCount }}/50 characters
          </mat-hint>
          <mat-error *ngIf="eventForm.get('name')?.hasError('required')">
            Name is required
          </mat-error>
          <mat-error *ngIf="eventForm.get('name')?.hasError('maxlength')">
            Maximum 50 characters allowed
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Rich Text Editor -->
      <div [ngClass]="{
      'editor-wrapper': true,
      'editor-invalid': eventForm.get('content')?.invalid && eventForm.get('content')?.touched
    }">
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
        <ngx-editor [editor]="editor" formControlName="content" placeholder="Add Description">
        </ngx-editor>
      </div>
      <!-- <div class="char-count">{{ characterCount }}/{{ maxCharacters }} characters</div> -->


      <!-- Dates and Times -->
      <div class="form-row date-time">
        <!-- Start Date & Time -->
        <mat-form-field appearance="outline">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startDate" [min]="minStartDate" />
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Start Time</mat-label>
          <input matInput type="time" formControlName="startTime" />
          <mat-error *ngIf="eventForm.get('startTime')?.hasError('pastTime')">Start time (ET) cannot be in the
            past</mat-error>
        </mat-form-field>
        <!-- End Date & Time -->
        <mat-form-field appearance="outline">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="endDate"
            [min]="eventForm.get('startDate')?.value || minStartDate" />
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>End Time</mat-label>
          <input matInput type="time" formControlName="endTime" />
          <mat-error *ngIf="eventForm.get('endTime')?.hasError('beforeStart')">End time must be after start
            time</mat-error>
        </mat-form-field>
      </div>
      <!-- Type / Capacity / Room -->
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Event Types</mat-label>
          <!-- <mat-select formControlName="type" multiple (selectionChange)="onTypeChange($event)">
            <mat-option value="Culinary">Culinary</mat-option>
            <mat-option value="Fitness">Fitness</mat-option>
            <mat-option value="Entertainment">Entertainment</mat-option>
            <mat-option value="Signature Experiences">Signature Experiences</mat-option>
          </mat-select> -->
          <mat-select formControlName="type" multiple (selectionChange)="onTypeChange($event)">
            <mat-option *ngFor="let tag of eventTags" [value]="tag.imageId">
              {{ tag.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="eventForm.get('type')?.hasError('required')">
            Please select at least one event type
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Capacity</mat-label>
          <input matInput type="number" min="1" formControlName="capacity" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Room</mat-label>
          <input matInput formControlName="room" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="image-picker-field" (click)="openImagePicker()">
          <mat-label>Event Image</mat-label>
          <input matInput formControlName="image" readonly [value]="getSelectedImageName()"
            placeholder="Click to select an image" class="image-picker-input">
        </mat-form-field>
      </div>

      <!-- Thumbnail below image field -->
      <div class="image-preview-inline image-view" *ngIf="eventForm.get('image')?.value">
        <img [src]="getSelectedImageUrl()" [alt]="getSelectedImageName()" class="inline-thumbnail"
          (click)="expandSelectedImage()" title="Click to view full image">
        <div class="image-hint" *ngIf="isDefaultImage()">
          <mat-icon>info</mat-icon>
          <span>Default image for {{ getPrimaryEventType() }} events</span>
        </div>
      </div>

    </form>




  </div>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="eventForm.invalid">Save</button>
  </div>
</div>

<!-- Full Image Modal -->
<div class="image-modal" *ngIf="selectedImageForExpand" (click)="closeExpandedImage()">
  <button class="close-btn" (click)="closeExpandedImage()">
    ×
  </button>
  <img [src]="selectedImageForExpand.content" [alt]="selectedImageForExpand.name" class="expanded-image"
    (click)="$event.stopPropagation()">
</div>

<!-- Image Picker Modal -->
<div class="image-picker-modal" *ngIf="showImagePicker">
  <div class="picker-content" (click)="$event.stopPropagation()">
    <div class="picker-header">
      <h3>Select an Image</h3>
      <button mat-icon-button class="close-modal-btn" (click)="closeImagePicker()" title="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

 <!-- Category Tabs -->
<div class="rv-tabs">
  <mat-button-toggle-group
    class="rv-tabs__group mat-elevation-z0"
    color="primary"
    name="cats"
    aria-label="Image categories"
    [value]="selectedCategory"
    (change)="selectCategory($event.value)">
    <mat-button-toggle *ngFor="let cat of categories" [value]="cat">
      {{ cat | titlecase }}
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>

    <!-- <div class="search-section">
      <div class="search-wrapper">
        <mat-icon class="search-icon">search</mat-icon>
        <input type="text" 
               class="search-input" 
               [(ngModel)]="imageSearchTerm" 
               placeholder="Search images by name...">
        <button *ngIf="imageSearchTerm" 
                class="clear-search-btn" 
                (click)="imageSearchTerm = ''">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div> -->

    <!-- <div class="image-categories">
      <button mat-button 
              [class.active]="selectedCategory === 'all'"
              (click)="filterByCategory('all')">
        <mat-icon>apps</mat-icon>
        All Images
      </button>
      <button mat-button 
              *ngFor="let category of getAvailableCategories()"
              [class.active]="selectedCategory === category"
              (click)="filterByCategory(category)">
        {{ category }}
      </button>
    </div> -->

    <div class="picker-grid">
      <!-- No Image Option -->
      <!-- <div class="picker-image-item" [class.selected]="isImageSelected('')" (click)="selectImageFromPicker('')">
        <div class="no-image-box">
          <mat-icon>hide_image</mat-icon>
          <span>No Image</span>
        </div>
      </div> -->


      <!-- Image Options -->
      <div class="picker-image-item" *ngFor="let img of filteredImages; trackBy: trackByImg" [class.selected]="isImageSelected(img.key)"
        (click)="selectImageFromPicker(img.key)">
        <img [src]="img.content" [alt]="img.name">
        <div class="selected-check" *ngIf="isImageSelected(img.key)">
          <mat-icon>check_circle</mat-icon>
        </div>
        <div class="picker-image-info">
          <span class="image-name">{{ img.key}}</span>
          <!-- <button class="preview-btn" 
                  (click)="previewImage(img, $event)"
                  title="Preview full size"
                  type="button">
            <mat-icon>zoom_in</mat-icon>
          </button> -->
        </div>
      </div>
    </div>

    <div class="picker-footer">
      <span class="image-count">
        <mat-icon>image</mat-icon>
        {{ filteredImages.length }} {{ filteredImages.length | i18nPlural: { '=0': 'image', '=1': 'image', 'other': 'images' } }} available
      </span>
      <div class="picker-actions">
        <button mat-stroked-button (click)="closeImagePicker()">
          <mat-icon>close</mat-icon>
          Cancel
        </button>
        <button mat-raised-button color="primary" (click)="confirmImageSelection()">
          <mat-icon>check</mat-icon>
          Apply Selection
        </button>
      </div>
    </div>
  </div>
</div>

<div class="error" *ngIf="eventForm.get('content')?.hasError('required') && eventForm.get('content')?.touched">
  Description is required
</div>